<div class="progress">
  <p cdkAriaLive="polite"  role="region" aria-label="Survey Status">Scenario {{ questNo + 1 }} of {{ totalQuestions }}</p>
  <mat-progress-bar
    [mode]="mode"
    [value]="value"
    aria-hidden="true">
  </mat-progress-bar>
</div>